<template>
  <v-footer v-if="getNotification.content" :color="getNotification.type" fixed app padless style="z-index: 9999; opacity: 0.85">
    <div class="col-md-11 text-center" style="color: #ffffff" v-html="getNotification.content"></div>
    <div class="col-md-1 text-center" style="color: #ffffff" v-if="getNotification.callback">
      <ed-button :iconLeft="$utilidade.getIcone('fechar')" color="#ffffff" onlyIcon text @click="getNotification.callback()" />
    </div>
  </v-footer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { EdButton } from "template";

export default {
  name: "EdNotification",
  components: { EdButton },
  data() {
    return {};
  },
  created() {
    jQuery("#carregando").hide();
  },
  mounted() {},
  computed: {
    ...mapGetters("common", ["getNotification"]),
  },
  methods: {
    ...mapActions("common", ["setNotification"]),
  },
  watch: {},
};
</script>

<style lang="scss">
@import "../../assets/css/error.scss";
.ed-error {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ececec;
  position: absolute;
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/components/template/EdNotification.vue